import api from "../../../components/axiosComp";

export const listPromos = async (params = {}) => {
  const { data } = await api.get("/api/promo-codes", { params });
  return data;
};

export const createPromo = async (payload) => {
  const { data } = await api.post("/api/promo-codes", payload);
  return data;
};

export const getPromoById = async (id) => {
  const { data } = await api.get(`/api/promo-codes/${id}`);
  return data;
};

export const updatePromo = async (id, payload) => {
  const { data } = await api.put(`/api/promo-codes/${id}`, payload);
  return data;
};

export const togglePromoStatus = async (id, isActive) => {
  const { data } = await api.patch(`/api/promo-codes/${id}/status`, { isActive });
  return data;
};

export const deletePromo = async (id) => {
  const { data } = await api.delete(`/api/promo-codes/${id}`);
  return data;
};